export var fromUTCToLocalTimeZone = function (date) {
    var toDate = new Date(date);
    toDate.setTime(toDate.getTime() + toDate.getTimezoneOffset() * -60000);
    return toDate;
};
